var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecurrance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Recurrance",
    transform: "translate(14457 -21020)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 24,
    height: 24,
    transform: "translate(-14457 21020)",
    fill: "#fff",
    opacity: 0.003
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-14437 21023) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Interface-Solid",
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "interface-solid-multimedia-refresh-button",
    d: "M10.254,0A7.517,7.517,0,0,0,2.737,7.388v.026c0,.029,0,.057,0,.085,0,.008,0,.014,0,.021v2.494L1.2,8.385a.695.695,0,0,0-1.011.953l2.736,2.905.009.006.016.015s0,.006.006.009a.668.668,0,0,0,.1.065.673.673,0,0,0,.1.065l.005,0,.01,0a.671.671,0,0,0,.521,0l.01,0,0,0a.671.671,0,0,0,.092-.062.651.651,0,0,0,.109-.069s0-.006.006-.009l.015-.015.008-.006L6.663,9.336a.694.694,0,1,0-1.012-.951L4.125,10.012v-2.6a6.132,6.132,0,1,1,6.13,6.2.694.694,0,1,0,0,1.389,7.5,7.5,0,1,0,0-15Z",
    transform: "translate(0.001 0)",
    fill: "#347af0"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecurrance);
export default __webpack_public_path__ + "static/media/recurrance.11d4835c534f39d8d59bdfecb618fcab.svg";
export { ForwardRef as ReactComponent };